const quota_item = {
    tenant_limit: {
        name: 'Tenant',
        limited: '{{count, number}} tenant',
        limited_other: '{{count, number}} tenant',
        unlimited: 'Không giới hạn tenant',
        not_eligible: 'Xóa các tenant của bạn',
    },
    mau_limit: {
        name: 'Người dùng hoạt động hàng tháng',
        limited: '{{count, number}} MAU',
        unlimited: 'Không giới hạn MAU',
        not_eligible: 'Xóa toàn bộ người dùng của bạn',
    },
    token_limit: {
        name: 'Token',
        limited: '{{count, number}} token',
        limited_other: '{{count, number}} token',
        unlimited: 'Không giới hạn token',
        not_eligible: 'Xóa toàn bộ người dùng của bạn để ngăn token mới',
    },
    applications_limit: {
        name: 'Ứng dụng',
        limited: '{{count, number}} ứng dụng',
        limited_other: '{{count, number}} ứng dụng',
        unlimited: 'Không giới hạn ứng dụng',
        not_eligible: 'Xóa các ứng dụng của bạn',
    },
    machine_to_machine_limit: {
        name: 'Máy tới máy',
        limited: '{{count, number}} ứng dụng máy tới máy',
        limited_other: '{{count, number}} ứng dụng máy tới máy',
        unlimited: 'Không giới hạn ứng dụng máy tới máy',
        not_eligible: 'Xóa các ứng dụng máy tới máy của bạn',
    },
    third_party_applications_limit: {
        name: 'Ứng dụng bên thứ ba',
        limited: '{{count, number}} ứng dụng bên thứ ba',
        limited_other: '{{count, number}} ứng dụng bên thứ ba',
        unlimited: 'Không giới hạn ứng dụng bên thứ ba',
        not_eligible: 'Xóa các ứng dụng bên thứ ba của bạn',
    },
    resources_limit: {
        name: 'Tài nguyên API',
        limited: '{{count, number}} tài nguyên API',
        limited_other: '{{count, number}} tài nguyên API',
        unlimited: 'Không giới hạn tài nguyên API',
        not_eligible: 'Xóa các tài nguyên API của bạn',
    },
    scopes_per_resource_limit: {
        name: 'Quyền theo tài nguyên',
        limited: '{{count, number}} quyền cho mỗi tài nguyên',
        limited_other: '{{count, number}} quyền cho mỗi tài nguyên',
        unlimited: 'Không giới hạn quyền cho mỗi tài nguyên',
        not_eligible: 'Xóa các quyền tài nguyên của bạn',
    },
    custom_domain_enabled: {
        name: 'Domain tùy chỉnh',
        limited: 'Domain tùy chỉnh',
        unlimited: 'Domain tùy chỉnh',
        not_eligible: 'Xóa domain tùy chỉnh của bạn',
    },
    omni_sign_in_enabled: {
        name: 'Đăng nhập đa kênh',
        limited: 'Đăng nhập đa kênh',
        unlimited: 'Đăng nhập đa kênh',
        not_eligible: 'Tắt đăng nhập đa kênh của bạn',
    },
    built_in_email_connector_enabled: {
        name: 'Liên kết email tích hợp',
        limited: 'Liên kết email tích hợp',
        unlimited: 'Liên kết email tích hợp',
        not_eligible: 'Xóa liên kết email tích hợp của bạn',
    },
    social_connectors_limit: {
        name: 'Liên kết mạng xã hội',
        limited: '{{count, number}} liên kết mạng xã hội',
        limited_other: '{{count, number}} liên kết mạng xã hội',
        unlimited: 'Không giới hạn liên kết mạng xã hội',
        not_eligible: 'Xóa các liên kết mạng xã hội của bạn',
    },
    standard_connectors_limit: {
        name: 'Liên kết chuẩn miễn phí',
        limited: '{{count, number}} liên kết chuẩn miễn phí',
        limited_other: '{{count, number}} liên kết chuẩn miễn phí',
        unlimited: 'Không giới hạn liên kết chuẩn',
        not_eligible: 'Xóa các liên kết chuẩn của bạn',
    },
    roles_limit: {
        name: 'Vai trò',
        limited: '{{count, number}} vai trò',
        limited_other: '{{count, number}} vai trò',
        unlimited: 'Không giới hạn vai trò',
        not_eligible: 'Xóa các vai trò của bạn',
    },
    machine_to_machine_roles_limit: {
        name: 'Vai trò máy tới máy',
        limited: '{{count, number}} vai trò máy tới máy',
        limited_other: '{{count, number}} vai trò máy tới máy',
        unlimited: 'Không giới hạn vai trò máy tới máy',
        not_eligible: 'Xóa các vai trò máy tới máy của bạn',
    },
    scopes_per_role_limit: {
        name: 'Quyền theo vai trò',
        limited: '{{count, number}} quyền cho mỗi vai trò',
        limited_other: '{{count, number}} quyền cho mỗi vai trò',
        unlimited: 'Không giới hạn quyền cho mỗi vai trò',
        not_eligible: 'Xóa các quyền vai trò của bạn',
    },
    hooks_limit: {
        name: 'Webhook',
        limited: '{{count, number}} webhook',
        limited_other: '{{count, number}} webhook',
        unlimited: 'Không giới hạn webhook',
        not_eligible: 'Xóa các webhook của bạn',
    },
    organizations_enabled: {
        name: 'Tổ chức',
        limited: 'Tổ chức',
        unlimited: 'Tổ chức',
        not_eligible: 'Xóa các tổ chức của bạn',
    },
    audit_logs_retention_days: {
        name: 'Thời gian lưu nhật ký kiểm tra',
        limited: 'Lưu nhật ký kiểm tra: {{count, number}} ngày',
        limited_other: 'Lưu nhật ký kiểm tra: {{count, number}} ngày',
        unlimited: 'Không giới hạn số ngày',
        not_eligible: 'Không có nhật ký kiểm tra',
    },
    email_ticket_support: {
        name: 'Hỗ trợ qua email',
        limited: '{{count, number}} giờ hỗ trợ qua email',
        limited_other: '{{count, number}} giờ hỗ trợ qua email',
        unlimited: 'Hỗ trợ qua email',
        not_eligible: 'Không có hỗ trợ qua email',
    },
    mfa_enabled: {
        name: 'Xác thực đa yếu tố',
        limited: 'Xác thực đa yếu tố',
        unlimited: 'Xác thực đa yếu tố',
        not_eligible: 'Xóa xác thực đa yếu tố của bạn',
    },
    sso_enabled: {
        name: 'SSO doanh nghiệp',
        limited: 'SSO doanh nghiệp',
        unlimited: 'SSO doanh nghiệp',
        not_eligible: 'Xóa SSO doanh nghiệp của bạn',
    },
    tenant_members_limit: {
        name: 'Thành viên tenant',
        limited: '{{count, number}} thành viên tenant',
        limited_other: '{{count, number}} thành viên tenant',
        unlimited: 'Không giới hạn thành viên tenant',
        not_eligible: 'Xóa các thành viên tenant của bạn',
    },
    custom_jwt_enabled: {
        name: 'JWT tùy chỉnh',
        limited: 'JWT tùy chỉnh',
        unlimited: 'JWT tùy chỉnh',
        not_eligible: 'Xóa bộ tùy biến claim JWT của bạn',
    },
    impersonation_enabled: {
        name: 'Giả lập người dùng',
        limited: 'Giả lập người dùng',
        unlimited: 'Giả lập người dùng',
        not_eligible: 'Không cho phép giả lập người dùng',
    },
    bring_your_ui_enabled: {
        name: 'Dùng giao diện riêng',
        limited: 'Dùng giao diện riêng',
        unlimited: 'Dùng giao diện riêng',
        not_eligible: 'Xóa tài nguyên giao diện tùy chỉnh của bạn',
    },
    collect_user_profile_enabled: {
        name: 'Thu thập hồ sơ người dùng',
        limited: 'Thu thập hồ sơ người dùng',
        unlimited: 'Thu thập hồ sơ người dùng',
        not_eligible: 'Xóa các trường thu thập hồ sơ người dùng của bạn',
    },
    idp_initiated_sso_enabled: {
        name: 'SSO khởi tạo từ IDP',
        limited: 'SSO khởi tạo từ IDP',
        unlimited: 'SSO khởi tạo từ IDP',
        not_eligible: 'Không cho phép SSO khởi tạo từ IDP',
    },
    saml_applications_limit: {
        name: 'Ứng dụng SAML',
        limited: '{{count, number}} ứng dụng SAML',
        limited_other: '{{count, number}} ứng dụng SAML',
        unlimited: 'Không giới hạn ứng dụng SAML',
        not_eligible: 'Xóa các ứng dụng SAML của bạn',
    },
    captcha_enabled: {
        name: 'CAPTCHA',
        limited: 'CAPTCHA',
        unlimited: 'CAPTCHA',
        not_eligible: 'Xóa CAPTCHA của bạn',
    },
    security_features_enabled: {
        name: 'Bảo mật nâng cao',
        limited: 'Bảo mật nâng cao',
        unlimited: 'Bảo mật nâng cao',
        not_eligible: 'Xóa cài đặt bảo mật nâng cao của bạn',
    },
    custom_domains_limit: {
        name: 'Domain tùy chỉnh',
        limited: '{{count, number}} domain tùy chỉnh',
        limited_other: '{{count, number}} domain tùy chỉnh',
        unlimited: 'Không giới hạn domain tùy chỉnh',
        not_eligible: 'Xóa các domain tùy chỉnh của bạn',
    },
    passkey_sign_in_enabled: {
        name: 'Đăng nhập bằng passkey',
        limited: 'Đăng nhập bằng passkey',
        unlimited: 'Đăng nhập bằng passkey',
        not_eligible: 'Không hỗ trợ đăng nhập bằng passkey',
    },
};
export default Object.freeze(quota_item);
